var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"context-menu"},[_c('VueContextMenu',{ref:"menu",on:{"ctx-cancel":_vm.ctxCancel}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }